<ham-modal
    [title]="title"
    [saveText]="saveLabel"
    [showCancelButton]="true"
    [cancelText]="cancelLabel"
    (save)="onSave()"
    (cancel)="onCancel()"
>
    <div class="new-account-form">
        <div class="form-group">
            <label>{{ accountNumberLabel }} <span class="required">*</span></label>
            <!-- hamInput is a ControlValueAccessor; use ngModel (standalone) so
                 the directive's internal display state (esp. for type=number) stays
                 in sync. Same pattern as the reclassification-modal inputs. -->
            <input
                hamInput
                class="new-account-number"
                [ngModel]="accountNumber"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="accountNumber = $event"
                [placeholder]="accountNumberPlaceholder"
                [class.input-error]="submitAttempted && (isAccountNumberEmpty || isAccountNumberDuplicate)"
            />
            <div class="field-error" *ngIf="submitAttempted && isAccountNumberEmpty">
                {{ errAccountNumberRequired }}
            </div>
            <div class="field-error" *ngIf="submitAttempted && isAccountNumberDuplicate">
                {{ errAccountNumberDuplicate }}
            </div>
        </div>

        <div class="form-group">
            <label>{{ accountNameLabel }} <span class="required">*</span></label>
            <input
                hamInput
                class="new-account-name"
                [ngModel]="accountName"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="accountName = $event"
                [placeholder]="accountNamePlaceholder"
                [class.input-error]="submitAttempted && isAccountNameEmpty"
            />
            <div class="field-error" *ngIf="submitAttempted && isAccountNameEmpty">
                {{ errAccountNameRequired }}
            </div>
        </div>

        <div class="form-group">
            <label>{{ fliLabel }} <span class="required">*</span></label>
            <!-- hamSimpleDropDown renders the selected option's label in the input
                 via its writeValue() hook. allowFreeText=false locks the input to
                 the supplied options. returnKey='id' makes the form value the picked option's `id`
                 field, which the parent fills with the FLI's internal `name` (matched by
                 findFliById on save). -->
            <input
                hamSimpleDropDown
                class="new-account-fli"
                [options]="fliOptions"
                [optionKeys]="['label']"
                returnKey="id"
                [allowFreeText]="false"
                [ngModel]="fliId"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="fliId = $event ?? ''"
                [placeholder]="fliPlaceholder"
                [class.input-error]="submitAttempted && isFliEmpty"
            />
            <div class="field-error" *ngIf="submitAttempted && isFliEmpty">
                {{ errFliRequired }}
            </div>
        </div>
    </div>
</ham-modal>
